import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/groups/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/groups/"!</div>;
}
